module.exports = __webpack_public_path__ + "static/media/type-2.61cf887a.svg";